import React, { useEffect, useState,useRef } from "react";
import { useParams,useNavigate } from "react-router-dom";
// import { IoChevronBackCircleOutline } from "react-icons/io5";

import instance,{lienPiece} from "../../../api/api";
// import Badge from "react-bootstrap/Badge";
// import {Help} from "../../../utils";
// import Spinner from "react-bootstrap/Spinner";

// import "primereact/resources/primereact.min.css";
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { TabView, TabPanel } from "primereact/tabview";

// import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";

// import MenuPoint from "../../../shared/compoments/MenuPoint.jsx"
// import { styleIcone } from "../../../shared";
// import { IoMdEye } from "react-icons/io";
// import { FiPlus } from "react-icons/fi";
import { GoPencil } from "react-icons/go";
import { Galleria } from "primereact/galleria";
import { Header,LoadingSpinner,InfoDetails } from "../../../shared/compoments";
import HomeIcon from "@mui/icons-material/Home";
import { LiaIdCardSolid } from "react-icons/lia";
import DetailBiensProprietaire from "./DetailBiensProprietaire";
// import { handleSeeIdentityCard } from "../../../store/slice/GalerieContrat";
// import { useSelector, useDispatch } from "react-redux";

function DetailClient() {
  const navigate = useNavigate();
  const galleria = useRef(null);
  const { id } = useParams();
  const [detailClient, setDetailClient] = useState(null);
  const [detailInfo, setDetailInfo] = useState([]);
  const [showDetailBien, setShowDetailBien] = useState(false);
  // const dispatch = useDispatch();
  // const seeIdentityCards = useSelector(
  //   (state) => state.galerie.seeIdentityCards
  // );
  const dataInfoDetail = (biens) => {
    const element = [];
    element.push({ title: "NOMBRE DE BIENS", value: String(biens.length) });
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };
  

  const itemTemplate = (item) => {
    return (
      <img
        src={lienPiece+item.path}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  useEffect(() => {
    const getDetailClient = async () => {
      try {
        const response = await instance.get(`/users/${id}`);
        console.log("getDetailClient25", response);
        const { biens } = response.data.data;
        dataInfoDetail(biens);
        setDetailClient(response.data.data);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getDetailClient();
  }, [id]);

const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Voir les biens",
      icone: <HomeIcon />,
      isColor:false,
      isVisible:detailClient?.biens.length > 0 ? true:false,
      methode: () => {
        setShowDetailBien(true);
      },
    },
      {
      titleBtn: "Modifier les infos",
      icone: <GoPencil />,
      isColor:false,
      isVisible:true,
      methode: () => {
        navigate("/proprietaire/edit/"+detailClient.id)
      },
    },
    {
      titleBtn: "Voir la pièce d'identité",
      icone: <LiaIdCardSolid />,
      isColor:false,
      isVisible:detailClient?.photos.length > 0 ? true:false,
      methode:()=>{
        // dispatch(handleSeeIdentityCard()); 
        console.log("galleria.current",galleria.current)
          galleria.current.show()
       }
    },
  ];

  return (
    <>
  
    <Galleria
      ref={galleria}
      value={detailClient?.photos}
      numVisible={9}
      style={{ maxWidth: "50%" }}
      circular
      fullScreen
      showItemNavigators
      showThumbnails={false}
      item={itemTemplate}
      thumbnail={thumbnailTemplate}
    />
      {detailClient != null ? (
        <>
          {!showDetailBien && (
            <section>
              <Header libelle={"Détails propriétaire"} isReturn />
              <div className="detail-student">
                <section>
                  <InfoDetails
                    namePerson={`${detailClient.nom} ${detailClient.prenom}`}
                    detailPhone={detailClient.phone}
                    detailAdresse={detailClient.adresse}
                    detailEmail={detailClient.email}
                    titleInfo={"Informations sur les Biens"}
                    dataInfo={detailInfo}
                    widthBody={"63%"}
                    dataBtnWithOptions={DATA_BTN_WITH_CONTRAT_OPTIONS
                    }
                  />
                </section>
              </div>
            </section>
          )}
          {showDetailBien && (
            <DetailBiensProprietaire
              items={detailClient?.biens}
              nameOfOwner={`${detailClient.nom} ${''} ${detailClient.prenom}`}
              showDetailBien={showDetailBien}
              setShowDetailBien={setShowDetailBien}
            />
          )}
        </>
      ) : (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <LoadingSpinner />
        </div>
      )}
    </>
  );
}

export default DetailClient;
